export default function Marquee({ items, className = "" }) {
  const strip = (key) => (
    <div key={key} className="flex shrink-0 items-center">
      {items.map((item, i) => (
        <span key={i} className="flex items-center whitespace-nowrap">
          <span className="font-display font-bold uppercase tracking-wider">{item}</span>
          <span className="mx-6 inline-block h-2 w-2 rounded-full bg-coral" aria-hidden="true" />
        </span>
      ))}
    </div>
  );
  return (
    <div className={`relative overflow-hidden ${className}`} data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee">
        {strip(0)}
        {strip(1)}
      </div>
    </div>
  );
}
